export default {
    apiKey: 'AIzaSyBcb-o73d-YLGLVm7unj_Yi-FNxeTsmo3E',
    spreadsheetId: '1sAEC7d8tcfiPVNBl-aFbIPgeb1YCp2HRcDN5-inc-44'
}
